/* OML: añade las composiciones configuradas al mega menú nativo sin reemplazar sus enlaces ni eventos. */
(() => {
  if (window.__omlMegaPromoInstalled) return;
  window.__omlMegaPromoInstalled = true;

  const pathOf = (url) => {
    if (!url) return null;
    try {
      const parsed = new URL(url, window.location.href);
      if (parsed.origin !== window.location.origin) return null;
      return decodeURI(parsed.pathname).replace(/\/+$/, '') || '/';
    } catch (_) { return null; }
  };

  const apply = () => {
    document.querySelectorAll('header-menu').forEach((header) => {
      const sources = header.querySelectorAll('.oml-mega-promo-source[data-menu-url]');
      if (!sources.length) return;
      const anchors = [...header.querySelectorAll('.menu-list__list-item > .menu-list__trigger > a.menu-list__link')];
      sources.forEach((source) => {
        if (source.dataset.enabled !== 'true') return;
        const wanted = pathOf(source.dataset.menuUrl);
        if (!wanted) return;
        const anchor = anchors.find((a) => pathOf(a.getAttribute('href')) === wanted);
        if (!anchor) return;
        const listItem = anchor.closest('.menu-list__list-item');
        const grid = listItem?.querySelector(':scope > .menu-list__submenu .mega-menu__grid');
        if (!grid || !grid.querySelector(':scope > .mega-menu__list')) return;
        // Actualiza el layout aunque la vista previa ya tenga el banner insertado.
        const inRange = (value, min, max, fallback) => {
          const number = Number.parseInt(value, 10);
          return Number.isFinite(number) ? Math.max(min, Math.min(max, number)) : fallback;
        };
        const horizontal = ['start', 'center', 'end'].includes(source.dataset.linksHorizontal)
          ? source.dataset.linksHorizontal : 'center';
        const vertical = ['start', 'center', 'end'].includes(source.dataset.linksVertical)
          ? source.dataset.linksVertical : 'center';
        grid.style.setProperty('--oml-nav-width', inRange(source.dataset.navWidth, 25, 50, 35) + '%');
        grid.style.setProperty('--oml-column-gap', inRange(source.dataset.columnGap, 0, 64, 16) + 'px');
        grid.style.setProperty('--oml-content-width', inRange(source.dataset.contentWidth, 1000, 2000, 1600) + 'px');
        grid.style.setProperty('--oml-link-horizontal', horizontal);
        grid.style.setProperty('--oml-link-vertical', vertical);
        if (grid.querySelector(':scope > .oml-mega-promo-visual')) return;
        const visual = source.querySelector('.oml-mega-promo-visual');
        if (!visual) return;
        const copy = visual.cloneNode(true);
        copy.style.cssText = source.style.cssText;
        grid.classList.add('oml-mega-grid');
        grid.appendChild(copy);
      });
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; apply(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => m.addedNodes.length > 0 || m.removedNodes.length > 0)) schedule();
  });
  const startObserver = () => { if (document.body) observer.observe(document.body, {childList:true,subtree:true}); };
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, {once:true});
})();